import { Component, OnInit, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

/** Имя BroadcastChannel, через который вкладки узнают о выходе. */
export const FRONTCHANNEL_LOGOUT_CHANNEL = 'nok-frontchannel-logout';

/**
 * Front-channel logout: Keycloak открывает этот адрес в скрытом iframe при выходе из любого сервиса
 * (URL задан в клиенте nok-spa). Чистим локальную сессию и сообщаем остальным вкладкам.
 */
@Component({
    selector: 'app-frontchannel-logout',
    template: '',
})
export class FrontchannelLogout implements OnInit {
    private readonly oidc = inject(OidcSecurityService);

    ngOnInit(): void {
        this.oidc.logoffLocal();
        const channel = new BroadcastChannel(FRONTCHANNEL_LOGOUT_CHANNEL);
        channel.postMessage({ type: 'logout' });
        channel.close();
    }
}
